import createReducer from '../createReducer';
import {TAvenueStatsState} from './avenueStats.type';

export const initialStateAvenueStats: TAvenueStatsState = {
    stats: {pageViews: null, uniqueUsers: null, customers: 0, transactions: 0, tickets: 0, avgLtv: null},
    avenue: null
};

const reducer = createReducer('avenueStats', initialStateAvenueStats);

export default reducer;
